__turbopack_context__.v({
  "error": "styles-module-scss-module__TeZAZq__error",
  "label": "styles-module-scss-module__TeZAZq__label",
  "option": "styles-module-scss-module__TeZAZq__option",
  "root": "styles-module-scss-module__TeZAZq__root",
  "select": "styles-module-scss-module__TeZAZq__select",
  "selectEmpty": "styles-module-scss-module__TeZAZq__selectEmpty",
  "selectError": "styles-module-scss-module__TeZAZq__selectError",
  "small": "styles-module-scss-module__TeZAZq__small",
});
